module.exports = __webpack_public_path__ + "static/media/1_A1_09.5dec7cad.png";